export const products=[
    {
        value: "Золотое кольцо с бриллиантами и изумрудом"
    },
    {
        value: "Золотое кольцо с топазом и бриллиантами"
    },
    {
        value: "Золотое кольцо с бриллиантами"
    },
    {
        value: "Золотое колье с бриллиантами и ониксом Pasquale Bruni"
    },
    {
        value: "Золотое кольцо с бриллиантами и жемчугом"
    },
    {
        value: "Золотое колье с рубинами и бриллиантами"
    },
    {
        value: "Золотые серьги с бриллиантами и сапфирами"
    },
    {
        value: "Золотые серьги с бриллиантами"
    },
    {
        value: "Золотое кольцо с бриллиантами и гранатом"
    },
    {
        value: "Золотые серьги с бриллиантами и  Аметистами"
    },
    {
        value: "Золотое кольцо с бриллиантом"
    },
    {
        value: "Золотой браслет с бриллиантами и аметистами"
    },
    {
        value: "Золотое кольцо с бриллиантами и сапфиром"
    },
    {
        value: "Золотое кольцо с дымчатым кварцем"
    },
    {
        value: "Золотой комплект с аметистами и хризолитом"
    },
    {
        value: "Комплект с изумрудами и бриллиантами Русские самоцветы"
    },
    {
        value: "Золотые серьги с бриллиантами  бирюзой и сапфирами"
    },
    {
        value: "Антикварная серебряная ложка"
    },
    {
        value: "Золотые серьги СССР  с бриллиантами"
    },
    {
        value: "Золотой кулон с бриллиантами и изумрудами"
    },
    {
        value: "Золотой кулон с аметистом и топазами"
    },
    {
        value: "Золотое кольцо с рубинами и бриллиантами"
    },
    {
        value: "Золотые серьги с топазами и гранатами"
    },
    {
        value: "Золотое кольцо с изумрудом и бриллиантами"
    },
    {
        value: "Золотое кольцо с бриллиантами и  самоцветами"
    },
    {
        value: "Золотое кольцо с самоцветами"
    },
    {
        value: "Золотая брошь с жемчугом"
    },
    {
        value: "Золотое колье с бриллиантами"
    },
    {
        value: "Золотое кольцо с Жадеитом и бриллиантами"
    },
    {
        value: "Золотое кольцо с изумрудом"
    },
    {
        value: "Золотые серьги с цветными фианитами"
    },
    {
        value: "Золотое кольцо VAN cleef & arpels"
    },
    {
        value: "Золотые серьги СССР с бриллиантами"
    },
    {
        value: "Золотые серьги с самоцветами"
    },
    {
        value: "Золотые серьги с морским жемчугом"
    },
    {
        value: "Золотые пусеты с бриллиантами"
    },
    {
        value: "Золотой браслет с бриллиантами"
    },
    {
        value: "Золотые серьги с бриллиантами и жемчугом"
    },
    {
        value: "Золотой подвес кулон с топазом и бриллиантами"
    },
    {
        value: "Золотая цепочка"
    },
    {
        value: "Золотое кольцо с бриллиантами СССР"
    },
    {
        value: "Золотой кулон с бриллиантами"
    },
    {
        value: "Золотое кольцо с хризолитом"
    },
    {
        value: "Золотые серьги с бриллиантами  и сапфирами"
    },
    {
        value: "Золотое кольцо с бриллиантами и аметистом"
    },
    {
        value: "Золотой браслет с бриллиантами De Beers"
    },
    {
        value: "Золотой кулон брошь  с  бриллиантами и рубинами"
    },
    {
        value: "Золотое кольцо с нефритом СССР"
    },
    {
        value: "Золотое колье с подвеской бренд Faberge"
    },
    {
        value: "Золотое кольцо с бриллиантами и рубинами"
    },
    {
        value: "Золотое кольцо с топазами"
    },
    {
        value: "Золотые серьги с бриллиантами и изумрудами"
    },
    {
        value: "Золотое кольцо с бриллиантами и кварцем"
    },
    {
        value: "Золотые серьги с бриллиантами и перламутром"
    },
    {
        value: "Золотой кулон с бриллиантами и сапфиром"
    },
    {
        value: "Золотые серьги  с бриллиантами и аметистами"
    },
    {
        value: "Браслет с сапфирами и бриллиантами"
    },
    {
        value: "Золотое кольцо Mauboussin"
    },
    {
        value: "Золотое кольцо с сапфиром и  бриллиантами"
    },
    {
        value: "Золотое кольцо с сапфирами"
    },
    {
        value: "Золотое кольцо с бриллиантами гранатами и сапфирам"
    },
    {
        value: "Золотое кольцо"
    },
    {
        value: "Золотые серьги с сапфирами и бриллиантами"
    },
    {
        value: "Серебряное кольцо с цирконием"
    },
    {
        value: "Оригинальное колье Van Cleef & Arpels"
    },
    {
        value: "Золотой браслет плетение бисмарк большой"
    },
    {
        value: "Золотое кольцо с бриллиантами и изумрудами"
    },
    {
        value: "Антикварные золотые серьги с алмазами"
    },
    {
        value: "Золотой комплект с изумрудами"
    },
    {
        value: "Золотое кольцо с сапфиром и бриллиантами"
    },
    {
        value: "Золотоые серьги с топазами и бриллиантами"
    },
    {
        value: "Золотое кольцо с бриллиантами и самоцветами"
    },
    {
        value: "Золотые серьги Черепашки"
    },
    {
        value: "Золотой комплект с аметистом и бриллиантом"
    },
    {
        value: "Золотой комплект с жемчугом"
    },
    {
        value: "Золотое кольцо с бриллиантами и сапфирами"
    },
    {
        value: "Золотые серьги пусеты с фианитами"
    },
    {
        value: "Золотые серьги пусеты с бриллиантами"
    },
    {
        value: "Жемчужное колье и пусеты Kimono"
    },
    {
        value: "Золотая брошь с бриллиантами"
    },
    {
        value: "Золотые серьги с изумрудами и самоцветами"
    },
    {
        value: "Оригинальное золотое кольцо Cartier"
    },
    {
        value: "Золотое колье  с бриллиантами"
    },
    {
        value: "Золотые серьги с кварцем и бриллиантами"
    },
    {
        value: "Золотые серьги с бриллиантами  гранатом хризолит и кварц"
    },
    {
        value: "Золотое кольцо с бриллиантами Van Cleef & Arpels"
    },
    {
        value: "Золотые серьги СССР"
    },
    {
        value: "Золотой браслет с бриллиантами и рубинами"
    },
    {
        value: "Золотое кольцо с цитрином"
    },
    {
        value: "Золотые серьги с бриллиантами  изумрудами и шпинелью"
    },
    {
        value: "Золотой комплект с бриллиантами аметистами, цитринами, топазами"
    },
    {
        value: "Золотое кольцо Chopard"
    },
    {
        value: "Золотое кольцо с изумрудами топазами  хризолитами и кварцем"
    },
    {
        value: "Золотая брошь \"Рыбка\" с рубином"
    },
    {
        value: "Золотой комплект с сапфирами"
    },
    {
        value: "Золотое кольцо с сапфиром и бриллиаетами"
    },
    {
        value: "Золотое кольцо с жемчугом"
    },
    {
        value: "Золотые серьги с рубинами и бриллиантами"
    },
    {
        value: "Колье с бриллиантами и кварцем Stephen Webster"
    },
    {
        value: "Золотой кулон с изумрудами"
    },
    {
        value: "Золотое итальянское колье с бриллиантами и сапфиром"
    },
    {
        value: "Золотые серьги с бриллиантами  танзанитом и сапфир"
    },
    {
        value: "Золотое колье с Аметистом и бриллиантами"
    },
    {
        value: "Золотое кольцо с аметистами"
    },
    {
        value: "Золотое кольцо с корундом"
    },
    {
        value: "Золотое кольцо с аметистом"
    },
    {
        value: "Золотой комплект с цитринами и хризолитами"
    },
    {
        value: "Золотой браслет с сапфирами"
    },
    {
        value: "Золотой комплект с бриллиантами и хризолитами"
    },
    {
        value: "Золотой браслет  с бриллиантами"
    },
    {
        value: "Золотой комплект с самоцветами"
    },
    {
        value: "Золотые серьги с бриллиантами и хризолитами"
    },
    {
        value: "Золотое кольцо бриллиантами и изумрудами"
    },
    {
        value: "Золотое кольцо Bvulgari"
    },
    {
        value: "Золотой браслет плетение корда средний"
    },
    {
        value: "Золотой комплект с самоцветами и бриллиантами"
    },
    {
        value: "Антикварная брошь подвес с бриллиантами"
    },
    {
        value: "Золотое кольцо с рубинами и  бриллиантами"
    },
    {
        value: "Золотое кольцо Tiffany & Co"
    },
    {
        value: "Золотые серьги с аметистами и бриллиантами"
    },
    {
        value: "Золотое кольцо с бриллиантами и шпинелью"
    },
    {
        value: "Золотое кольцо с бриллиантами и топазом"
    },
    {
        value: "Золотое кольцо с аметистами и лавандовым жадеитом"
    },
    {
        value: "Золотое советское кольцо кольцо обручальное"
    },
    {
        value: "Золотая цепь белое золото"
    },
    {
        value: "Золотой браслет с изумрудами и бриллиантами"
    },
    {
        value: "Золотое колье с природной шпинелью"
    },
    {
        value: "Золотой кулон с дымч кварцем и бриллиантами"
    },
    {
        value: "Золотой кулон с сапфиром и бриллитантами"
    },
    {
        value: "Золотые серьги с бриллиантами эпл"
    },
    {
        value: "Оригинальное платиновое кольцо De Beers"
    },
    {
        value: "Золотой кулон с жемчугом и бриллиантами"
    },
    {
        value: "Золотой кулон ссср с дымчатым кварцем"
    },
    {
        value: "Золотые серьги с дымч кварцем и бриллиантами"
    },
    {
        value: "Золотая брошь с сапфирами и бриллиантами"
    },
    {
        value: "Золотое кольцо с бриллиантами и хризолитом"
    },
    {
        value: "Золотые серьги с хризолитами"
    },
    {
        value: "Золотое кольцо с рубином и бриллиантами"
    },
    {
        value: "Золотое колье с бриллиантами Damiani Infinito"
    },
    {
        value: "Кожаный браслет на магните"
    },
    {
        value: "Золотые серьги с бриллиантами  и кварц дымчатый"
    },
    {
        value: "Золотое кольцо с аметистами хризолитами гранатами иолитами"
    },
    {
        value: "Золотой браслет с изумрудами"
    },
    {
        value: "Золотое кольцо Тиффани"
    },
    {
        value: "Золотое кольцо с бриллиантами сапфирами"
    },
    {
        value: "Золотые серьги с натуральными рубинами и бриллиант"
    },
    {
        value: "Золотой  с бриллиантом"
    },
    {
        value: "Золотые серьги с бриллиантами СССР"
    },
    {
        value: "Золотые серьги с бриллиантами  и самоцветами"
    },
    {
        value: "Оригинальное золотое кольцо Chaumet"
    },
    {
        value: "Золотые серьги с бриллиантами  и изумрудами"
    },
    {
        value: "Золотые серьги с кварцем  гранатами  хризолитами и бриллиантами"
    },
    {
        value: "Золотой комплект  СССР с кораллом"
    },
    {
        value: "Золотое кольцо с бриллиантами и перламутром"
    },
    {
        value: "Золотое кольцо ссср"
    },
    {
        value: "Золотое кольцо с бриллиантами рубином и сапфирами"
    },
    {
        value: "Золотое кольцо с жемчугом и бриллиантами"
    },
    {
        value: "Золотой комплект с бриллиантами и рубинами"
    },
    {
        value: "Золотой комплект с топазами"
    },
    {
        value: "Золотые серьги с фианитами"
    },
    {
        value: "Золотые серьги с топазами и аметистами"
    },
    {
        value: "Оригинальное платиновое кольцо Cartier"
    },
    {
        value: "Золотой комплект с бриллиантами"
    },
    {
        value: "Оригинальное золотое колье Graff"
    },
    {
        value: "Золотой комплект с сапфирами и бриллиантами"
    },
    {
        value: "Золотые серьги  с топазами и бриллиантами"
    },
    {
        value: "Золотой комплект с бриллиантами Casa Gi"
    },
    {
        value: "Серьги с кварцами и бриллиантами"
    },
    {
        value: "Золотой браслет с сапфирами и бриллиантами"
    },
    {
        value: "Золотой браслет плетение нонна малый"
    },
    {
        value: "2000000111759"
    },
    {
        value: "Серебряный подстаканник"
    },
    {
        value: "Золотое кольцо с жемчугом Мабе бриллиантами и изумрудами"
    },
    {
        value: "Антикварный кулон с демантоидами, рубинами, хризолитами  и ру"
    },
    {
        value: "Золотые серьги  с бриллиантами"
    },
    {
        value: "Золотое кольцо с бриллиантами сапфиром"
    },
    {
        value: "Золотые серьги с изумрудами и бриллиантами"
    },
    {
        value: "Золотой кулон с аметистом и бриллиантом"
    },
    {
        value: "Платиновое кольцо Tiffani"
    },
    {
        value: "Золотое кольцо с рубинами и бриллиантом"
    },
    {
        value: "Золотое обручальное кольцо ссср"
    },
    {
        value: "Золотой кулон с лимонным кварцем и бриллиантами"
    },
    {
        value: "Серебряный кулон с фианитами"
    },
    {
        value: "Золотой кулон с жемчугом"
    },
    {
        value: "Золотые серьги с корундами"
    },
    {
        value: "Золотое кольцо с апофиллитом и бриллиантами"
    },
    {
        value: "Антикварный серебряный подстаканник"
    },
    {
        value: "Золотой антикварный браслет с бирюзой"
    },
    {
        value: "Антикварное колье с бриллиантами"
    },
    {
        value: "Золотые антикварные серьги с бирюзой"
    },
    {
        value: "Золотой комплект с Аметистами и топазами"
    },
    {
        value: "Золотой кулон с бриллиантами и халцедоном"
    },
    {
        value: "Золотые серьги аметистами и хризолитами"
    },
    {
        value: "Золотая цепь новая различного плетения"
    },
    {
        value: "Золотой браслет с бриллиантами и рубинами Roberto Cion"
    },
    {
        value: "Золотое кольцо с бриллиантами и топазами"
    },
    {
        value: "Золотой комплект с спессартином и бриллиантами"
    },
    {
        value: "Золотые серьги с бирюзой и топазами"
    },
    {
        value: "Золотые серьги с гранатами и бриллиантами"
    },
    {
        value: "Золотой кулон с аметистами"
    },
    {
        value: "Золотое кольцо с бриллиантами и рубином"
    },
    {
        value: "Золотая цепь плетение шнурок"
    },
    {
        value: "Золотое кольцо с жемчугом и фианитами"
    },
    {
        value: "Золотые серьги с бриллиантами  и жемчугом"
    },
    {
        value: "Золотое колье Happy Bear бренд Chopard оригинал"
    },
    {
        value: "Золотая цепь новая плетение корда"
    },
    {
        value: "Кольцо с бриллиантами и молочным кварцем"
    },
    {
        value: "Золотые серьги с аметистами сапфирами хризолитами гранатом и иолитом"
    },
    {
        value: "Золотые пусеты с жемчугом"
    },
    {
        value: "Золотое кольцо -кулон с бриллиантами"
    },
    {
        value: "Золотые серьги с бриллиантами EPL"
    },
    {
        value: "Золотое кольцо с бриллиантом и сапфирами"
    },
    {
        value: "Золотое кольцо с бриллиантами изумрудами сапфирами и рубинами"
    },
    {
        value: "Серебряное кольцо с фианитами"
    },
    {
        value: "Колье с бриллиантом Chopard оригинал"
    },
    {
        value: "Золотой кулон с бриллиантами и рубином"
    },
    {
        value: "Золотой браслет с топазами"
    },
    {
        value: "Подвес с сапфиром бриллиантами с цепочкой"
    },
    {
        value: "Золотые серьги с халцедоном и топазами"
    },
    {
        value: "Золотой кулон с ониксом"
    },
    {
        value: "Золотые серьги с цитринами и топазами"
    },
    {
        value: "Золотое кольцо с бриллиантами и цитрином"
    },
    {
        value: "Золотые серьги  с бриллиантами СССР"
    },
    {
        value: "Золотое кольцо с бриллиантами эпл"
    },
    {
        value: "Золотое кольцо с сапфирами и топазами"
    },
    {
        value: "Оригинальное золотое кольцо Pomellato"
    },
    {
        value: "Золотое кольцо с бриллиантами и с цитринами"
    },
    {
        value: "Золотое кольцо с сапфирами и рубинами"
    },
    {
        value: "Золотой кулон с бриллиантом"
    },
    {
        value: "Золотые серьги с Халцедонами и бриллиантами"
    },
    {
        value: "Золотые серьги с бриллиантами  и танзанитами"
    },
    {
        value: "Золотой комплект с бриллиантами и перламутром"
    },
    {
        value: "Золотое кольцо с топазом и черн бриллиантами"
    },
    {
        value: "Золотой кулон с сапфиром и бриллиантами"
    },
    {
        value: "Золотое кольцо СССР с изумрудом и бриллиантами"
    },
    {
        value: "Золотое кольцо эпл с бриллиантами"
    },
    {
        value: "Золотое кольцо Bvlgari"
    },
    {
        value: "Золотой кулон с кварцем и бриллиантами"
    },
    {
        value: "Золотые серьги с дымчатым кварцем"
    },
    {
        value: "Золотое кольцо с изумрудами и бриллиантами"
    },
    {
        value: "Золотое кольцо с бриллиантами и  сапфиром"
    },
    {
        value: "Золотое кольцо с кварцем и бриллиантами"
    },
    {
        value: "Золотые серьги с бриллиантами  и турмалинами"
    },
    {
        value: "Золотое кольцо с аквамарином и бриллиантами"
    },
    {
        value: "Золотой антикварный кулон-локет"
    },
    {
        value: "Золотые серьги с сапфирами"
    },
    {
        value: "Золотой комплект с иолитами-кардиеритами и бриллиантами"
    },
    {
        value: "Золотой комплект с жадеитом и бриллиантами"
    },
    {
        value: "Золотое кольцо с бриллиантами и гранатом родолитом"
    },
    {
        value: "Золотое кольцо с рубинами"
    },
    {
        value: "Золотое кольцо с кварцем жадеитом и топазом"
    },
    {
        value: "Золотые серьги пусеты с бриллиантами и Аметистами"
    },
    {
        value: "Золотой браслет плетение нонна"
    },
    {
        value: "Платиновое  кольцо Tiffani (платина )"
    },
    {
        value: "Золотое кольцо Cartier"
    },
    {
        value: "Золотые серьги  с бриллиантами и жемчугом"
    },
    {
        value: "Золотой кулон с сапфирами на цепочке"
    },
    {
        value: "Золотое кольцо с цитринами и хризолитом"
    },
    {
        value: "Золотое кольцо с рубином"
    },
    {
        value: "Золотая брошь с сапфиром и демантоидами"
    },
    {
        value: "Золотой кулон с топазом"
    },
    {
        value: "Золотое кольцо с бриллиантами бренд Chopard"
    },
    {
        value: "Золотое кольцо с топазом"
    },
    {
        value: "Золотой антикварный браслет 56проба"
    },
    {
        value: "Золотая брошь с бриллиантами и сапфирами"
    },
    {
        value: "Золотые серьги с рубинами  и сапфирами"
    },
    {
        value: "Браслет с жемчугом"
    },
    {
        value: "Золотые серьги бренд Faberge"
    },
    {
        value: "Золотое кольцо с турмалином и бриллиантами"
    },
    {
        value: "Золотой комплект с бриллиантами и самоцветами"
    },
    {
        value: "Платиновые пусеты с бриллиантами"
    },
    {
        value: "Золотое антикварное  кольцо с бриллиантом"
    },
    {
        value: "Мужской перстень с бриллиантами"
    },
    {
        value: "Золотые серьги с бирюзой и бриллиантами СССР"
    },
    {
        value: "Золотые серьги с бриллиантами  и топазами"
    },
    {
        value: "Золотое кольцо с аметистом и топазом"
    },
    {
        value: "Золотой кулон с розовым кварцем Chopardd"
    },
    {
        value: "Оригинальная подвеска Chaumet Heart с бриллиантами"
    },
    {
        value: "Колье золотое с бриллиантами и рубинами"
    },
    {
        value: "Оригинальный золотой кулон Pasquale Bruni"
    },
    {
        value: "Золотое кольцо с бирюзой топазами и иолитами"
    },
    {
        value: "Золотые серьги с бриллиантами  и зел аметист"
    },
    {
        value: "Золотое кольцо с бриллиантами и керамикой"
    },
    {
        value: "Золотой подвес с бриллиантами и аметистом"
    },
    {
        value: "Золотые серьги с топазами бриллиантами и рубинами Pomellato"
    },
    {
        value: "Золотые серьги с жемчугом Таити и бриллиантами"
    },
    {
        value: "Антикварная золотая  брошь с бриллиантами"
    },
    {
        value: "Золотое кольцо с фианитами и рубинами"
    },
    {
        value: "Золотой кулон с бриллиантами и изумрудом"
    },
    {
        value: "Золотые серьги с лабор выращ  бриллиантами"
    },
    {
        value: "Золотые серьги с бриллиантами  и гранатами"
    },
    {
        value: "Золотое кольцо с сапфирами и бриллиантами"
    },
    {
        value: "Антикварная брошь с демантоидами"
    },
    {
        value: "Золотые серьги с бриллиантами  Chaumet"
    },
    {
        value: "Золотое кольцо с бриллиантом СССР"
    },
    {
        value: "Колье с сапфирами и бриллиантами"
    },
    {
        value: "Золотое кольцо с Халцедоном и бриллиантами"
    },
    {
        value: "Золотое кольцо с ониксом и бриллиантами"
    },
    {
        value: "Золотое кольцо с бриллиантами и гранатами"
    },
    {
        value: "Золотое кольцо с бриллиантами и аметистами"
    },
    {
        value: "Золотой кулон с бриллиантами, изумрудами и сапфира"
    },
    {
        value: "Золотое кольцо с Аметистами и топазами"
    },
    {
        value: "Золотое кольцо с кварцем  хризолитами и гранатами"
    },
    {
        value: "Золотой комплект с кварцем и бриллиантами"
    },
    {
        value: "Золотое кольцо с изумрудом и бриллиантами СССР"
    },
    {
        value: "Золотое кольцо с сапфиром"
    },
    {
        value: "Золотое кольцо обручальное"
    },
    {
        value: "Золотое кольцо обручальное ссср"
    },
    {
        value: "Золотой браслет с бриллиантами и топазами"
    },
    {
        value: "Золотые серьги с топазами"
    },
    {
        value: "Золотое кольцо с черными  бриллиантами и рубинамии"
    },
    {
        value: "Золотые серьги с изумрудами"
    },
    {
        value: "Золотой браслет ссср"
    },
    {
        value: "Золотые серьги с рубинами изумрудамии бриллиантами"
    },
    {
        value: "Золотые серьги с бриллиантами  Chopard"
    },
    {
        value: "Золотые серьги с бриллиантами  и топазами Judith Ripka"
    },
    {
        value: "Золотые серьги с бриллиантами и топазами"
    },
    {
        value: "Антикварная брошь кулон с демантоидами"
    },
    {
        value: "Золотые серьги с бриллиантами  и топазами CASATO"
    },
    {
        value: "Золотые серьги с бриллиантами и бирюзой"
    },
    {
        value: "Золотой подвес с бриллиантом"
    },
    {
        value: "Золотой браслет плетение якорное"
    },
    {
        value: "Золотая подвеска Bvlgari на кожаном шнуре"
    },
    {
        value: "Золотые серьги с раух-топазом"
    },
    {
        value: "Оригинальные золотые серьги Bvlgari"
    },
    {
        value: "Золотые серьги Bvlgari"
    },
    {
        value: "Золотой браслет Cartier"
    },
    {
        value: "Золотые серьги с жемчугом"
    },
    {
        value: "Золотое кольцо с бриллиантами с кварцем"
    },
    {
        value: "Золотые серьги с Аметистами"
    },
    {
        value: "Золотой браслет с бриллиантами и сапфирами Pomellato"
    },
    {
        value: "Браслет змейка с топазом,золотом, каучук"
    },
    {
        value: "Брошь золотая с жемчугом"
    },
    {
        value: "Золотой кулон с изумрудом"
    },
    {
        value: "Золотое колье с бриллиантами и изумрудами"
    },
    {
        value: "Золотое кольцо с рубинами и бриллинтами"
    },
    {
        value: "Золотое кольцо СССР с бриллиантами"
    },
    {
        value: "Золотые серьги с рубинами синт"
    },
    {
        value: "Золотые серьги с бриллиантами  танзанитами и сапфирами"
    },
    {
        value: "Золотые серьги с топазами и бриллиантами"
    },
    {
        value: "Золотой браслет на ногу"
    },
    {
        value: "Комплект серьги и кольцо с бриллиантами"
    },
    {
        value: "Серьги золотые с сапфирами и бриллиантами"
    },
    {
        value: "Золотое комплект с бирюзой и топазами"
    },
    {
        value: "Антикварные золотые серьги с сапфирами  и алмазами"
    },
    {
        value: "Золотые серьги с бриллианами бренд Damiani"
    },
    {
        value: "Золотое колье  с бриллиантами цитрином и турмалинами"
    },
    {
        value: "Золотой кулон с природными турмалинами"
    },
    {
        value: "Золотой кулон с сапфиром и бриллиантом"
    },
    {
        value: "Подвес с аметистами и бриллиантами"
    },
    {
        value: "Золотое кольцо с хризолитом и бриллиантами"
    },
    {
        value: "Золотой кулон с рубинами и розовым жадеитом"
    },
    {
        value: "Золотые серьги с бриллиантами и турмалинами"
    },
    {
        value: "Золотое кольцо с аметистами и хризолитом"
    },
    {
        value: "Антикварные золотые серьги с бирюзой"
    },
    {
        value: "Золотые серьги с аметистами Pomellato"
    },
    {
        value: "Золотые серьги с бриллиантами и кварцем"
    },
    {
        value: "Золотой подвес -кулон с топазом"
    },
    {
        value: "Оригинальное золотое кольцо Chopard"
    },
    {
        value: "Золотое кольцо с рубинами, турмалинами и бриллиант"
    },
    {
        value: "Золотое кольцо  с бриллиантами  цитринами турмалинами и аметистами"
    },
    {
        value: "Золотое колье с бриллиантами и самоцветами"
    },
    {
        value: "Золотые серьги с бриллиантами  и изумрудами сапфирами и рубинами"
    },
    {
        value: "Золотой кулон с  аметистами и топазами"
    },
    {
        value: "Золотой браслет с хризолитами"
    },
    {
        value: "Золотое кольцо ссср  с сапфиром и  бриллиантами"
    },
    {
        value: "Оригинальная подвеска Roberto Coin Heart"
    },
    {
        value: "Золотой комплект СССР  с Бирюзой"
    },
    {
        value: "Золотые серьги с жадеитом и бриллиантами"
    },
    {
        value: "Золотое кольцо с черными бриллиантами"
    },
    {
        value: "Золотое кольцо с бриллиантами и розовым кварцем"
    },
    {
        value: "Золотое кольцо и бриллиантом и рубинами Chopard"
    },
    {
        value: "Золотой комплект с бриллиантами и изумрудами"
    },
    {
        value: "Золотое кольцо с изумрудами и бриллитантами"
    },
    {
        value: "Золотое кольцо с аметистом и сапфирами"
    },
    {
        value: "Золотое кольцо с аметистом и бриллиантами"
    },
    {
        value: "Золотое колье с бриллиантом Chopard"
    },
    {
        value: "Золотое кольцо с бриллиантами и зеленым Аметистом"
    },
    {
        value: "Золотое кольцо с танзанитом и бриллиантами"
    },
    {
        value: "Золотое кольцо с муассанитом"
    },
    {
        value: "Золотое колье с бриллиантами и жемчугом"
    },
    {
        value: "Золотые серьги тюльпаны с бриллиантами"
    },
    {
        value: "Золотой браслет плетение корда малый"
    },
    {
        value: "Золотые серьги  с синтетич корундом"
    },
    {
        value: "Золотое кольцо с халцедоном"
    },
    {
        value: "Золотые серьги с сапфирами и  бриллиантами"
    },
    {
        value: "Золотые серьги пусеты  с бриллиантами"
    },
    {
        value: "Золотой комплект с цитрином и топазами"
    },
    {
        value: "Золотые серьги с корундами синт"
    },
    {
        value: "Золотой кулон с цитрином и бриллиантами"
    },
    {
        value: "Колье с бриллиантами и жемчугом Таити"
    },
    {
        value: "Антикварные золотые серьги с бриллиантами"
    },
    {
        value: "Золотые серьги Chopard les Chaines"
    },
    {
        value: "Комплект серьги и кольцо с родохрозитом с бриллиантами"
    },
    {
        value: "Серебряное кольцо с керамикой"
    },
    {
        value: "Золотой комплект с бриллиантами и жемчугом"
    },
    {
        value: "Кулон с жемчугом и бриллиантами"
    },
    {
        value: "Золотой браслет с гранатами"
    },
    {
        value: "Золотой комплект с дымчатым кварцем"
    },
    {
        value: "Золотое кольцо с Изумрудом и  бриллиантами"
    },
    {
        value: "Золотое кольцо со шпинелью"
    },
    {
        value: "Золотые серьги с бриллиантами и жемчугом  GV"
    },
    {
        value: "Золотые серьги с аметистами и жадеитами"
    },
    {
        value: "Золотой комплект с Халцедоном и бриллиантами"
    },
    {
        value: "Золотое кольцо с рубинами и аметистами"
    },
    {
        value: "Оригинальный золотой кулон Stephen Webster"
    },
    {
        value: "Золотые серьги с бриллиантами изумрудами и рубинами"
    },
    {
        value: "Оригинальное золотое кольцо De Grisogono Zucchero"
    },
    {
        value: "Золотой браслет с жадеитом и бриллиантами"
    },
    {
        value: "Золотые серьги"
    },
    {
        value: "Золотой комплекто с халцедоном"
    },
    {
        value: "Золотой кулон с бриллиантами и цепочкой"
    },
    {
        value: "Золотые серьги с руьинами и бриллиантами"
    },
    {
        value: "Золотой кулон с бриллиантами и жемчугом"
    },
    {
        value: "Золотое колье с бриллиантом"
    },
    {
        value: "Золотой комплект с изумрудами и бриллиантами"
    },
    {
        value: "Золотой антикварный браслет 56 проба"
    },
    {
        value: "Кулон Van Cleef & Arpels Button"
    },
    {
        value: "Золотые серьги с бриллиантами  и рубинами"
    },
    {
        value: "Золотое кольцо с аметистами и бриллиантами"
    },
    {
        value: "Золотые серьги с фианитами   и топазами"
    },
    {
        value: "Золотой браслет"
    },
    {
        value: "Золотой браслет с бриллиантами и изумрудами"
    },
    {
        value: "Золотое кольцо с бриллиантами и шпинель синт"
    },
    {
        value: "Золотое кольцо с турмалином  параиба и бриллиантами"
    },
    {
        value: "Золотые серьги с бриллиантами  и аметистами"
    },
    {
        value: "Золотое кольцо \"Кошка\" с бриллиантами и рубинами"
    },
    {
        value: "Золотое кольцо с Bvulgari"
    },
    {
        value: "Золотое кольцо с аметистом зеленым"
    },
    {
        value: "Золотой кулон с Аметистом и бриллиантами"
    },
    {
        value: "Золотое колье с бриллиантами Pasquale Bruni"
    },
    {
        value: "Золотой кулон с жемчугом на цепочке"
    },
    {
        value: "Золотое кольцо с изумрудами"
    },
    {
        value: "Золотой браслет с бриллиантами и халцедоном"
    },
    {
        value: "Золотые серьги с цитринами и хризолитами"
    },
    {
        value: "Золотое кольцо Мauboussin с дымчатым кварцем и бриллиантами"
    },
    {
        value: "Золотой кулон с сапфирами и бриллиантами"
    },
    {
        value: "Золотые серьги с медовым кварцем и бриллиантами"
    },
    {
        value: "Подвеска с бриллиантами"
    },
    {
        value: "Золотые серьги с гранатом и бриллиантами"
    },
    {
        value: "Золотые серьги с кварцем"
    },
    {
        value: "Золотая цепь плетение якорное"
    },
    {
        value: "Золотые советские серьги с корундами"
    },
    {
        value: "Золотая брошь с бриллиантами и самоцветами"
    },
    {
        value: "Золотое кольцо с бриллиантами и оникс"
    },
    {
        value: "Золотые советские  серьги с корундом и фианитами"
    },
    {
        value: "Золотой комплект с аметистом и бриллиантами"
    },
    {
        value: "Золотое уольцо с сафиром зведчатым и бриллиантами"
    },
    {
        value: "Золотое кольцо с аметистом и топазами"
    },
    {
        value: "Золотое кольцо с дымчатым кварцем и бриллиантами"
    },
    {
        value: "Серебряный постаканник"
    },
    {
        value: "Золотое кольуо с рубином и бриллианты"
    },
    {
        value: "Золотые серьги малинки с бриллиантами СССР"
    },
    {
        value: "Золотой комплект с бирюзой топазами и иолитами"
    },
    {
        value: "Золотое кольцо с фианитами"
    },
    {
        value: "Золотые серьги с жемчугом и агатом Mimi"
    },
    {
        value: "Золотые часы с бриллиантами Chopard"
    },
    {
        value: "Золотой комплект с бриллиантами и гранатом"
    },
    {
        value: "Золотое кольцо поцелуйчик с бриллиантами"
    },
    {
        value: "Золотая брошь с самоцветами"
    },
    {
        value: "Золтотые серьги с природными турмалинами"
    },
    {
        value: "Золотое кольцо с аметистом и хризолитами"
    },
    {
        value: "Золотой кулон с дымчатым кварцем и бриллантом"
    },
    {
        value: "Золотые серьги с бриллиантами  и кварцем"
    },
    {
        value: "Золотое кольцо с рубином  с бриллиантами"
    },
    {
        value: "Золотой браслет плетение корда"
    },
    {
        value: "Золотой кулон с молдвитом и гранатом"
    },
    {
        value: "Золотое кольцо с Лунным камнем и жадеитами"
    },
    {
        value: "Колье с бриллиантами и самоцветами Bvlgari"
    },
    {
        value: "Золотое кольцо с бриллиантами и турмалином"
    },
    {
        value: "Золотое кольцо с аметистом и кварцем"
    },
    {
        value: "Золотой кулон с фианитами"
    },
    {
        value: "Золотые серьги с бриллиантами и Аметистами"
    },
    {
        value: "Золотые советские серьги с бриллиантами"
    },
    {
        value: "Золотые антикварные серьги с бриллиантами"
    },
    {
        value: "Золотой кулон сердце с бриллиантами"
    },
    {
        value: "Золотые серьги с бриллиантами  цитринами и хризолитами"
    },
    {
        value: "Золотое кольцо с бриллиантами цитринами и шпинелью"
    },
    {
        value: "Комплект кольцо и серьги с бриллиантами"
    },
    {
        value: "Золотое кольцо с изумрудами и  бриллиантами"
    },
    {
        value: "Золотой крест Pomellato"
    },
    {
        value: "Золотые серьги с жадеитом"
    },
    {
        value: "Золотой кулон с самоцветами и бриллиантами"
    },
    {
        value: "Кольцо с фантазийным бриллиантом"
    },
    {
        value: "Золотые серьги с бриллиантами  Конго"
    },
    {
        value: "Золотой браслет с керамикой Bvlgari"
    },
    {
        value: "Золотое колье с бриллиантами и топазами"
    },
    {
        value: "Золотое кольцо сo сапфиром   и  бриллиантами"
    },
    {
        value: "Золотые серьги пусеты с бриллиантами и изумрудами"
    },
    {
        value: "Золотое кольцо с  жадеитом"
    },
    {
        value: "Золотое колье  с бриллиантами и аметистами"
    },
    {
        value: "Золотые серьги бриллиантами"
    },
    {
        value: "Оригинальное золотое кольцо de Grisogono"
    },
    {
        value: "Золотое кольцо с изумрудом гидротерм"
    },
    {
        value: "Золотой браслет с самоцветами"
    },
    {
        value: "Золотые серьги с бриллиантами  Audemars Piguet"
    },
    {
        value: "Брошь с бриллиантами и изумрудами"
    },
    {
        value: "Золотые пусеты с цитринами и бриллиантами"
    },
    {
        value: "Антикварные золотые серьги"
    },
    {
        value: "Золотой браслет с бриллиантами и самоцветами Bvlgari"
    },
    {
        value: "Золотой кулон-подвес с кварцем дымчатым и бриллиантами"
    },
    {
        value: "Золотое кольцо c бриллиантами  Audemars Pigue"
    },
    {
        value: "Золотые серьги с бриллиантами и рубинами"
    },
    {
        value: "Золотой кулон с гранатамии бриллиантами"
    },
    {
        value: "Золотое колье и браслет с бриллиантами"
    },
    {
        value: "Золотое кольцо с гранатами и бриллиантами"
    },
    {
        value: "Золотой кулон и бриллиантом и изумрудом"
    },
    {
        value: "Золотое кольцо с бриллиантами и  изумрудом"
    },
    {
        value: "Подвес с бриллиантом"
    },
    {
        value: "Золотое кольцо с рубином синтетич"
    },
    {
        value: "Золотое кольцо с зеленым сапфиром"
    },
    {
        value: "Золотое кольцо с бриллиантами и цитринами"
    },
    {
        value: "Золотое колье с топазами и бриллиантами"
    },
    {
        value: "Золотые серьги с аметистами и топазами"
    },
    {
        value: "Золотой  подвес с бриллиантами"
    },
    {
        value: "Золотое колье с бриллиантами Магерит"
    },
    {
        value: "Золотой комплект с бирюзой"
    },
    {
        value: "Золотое кольцо с самоцветами и бриллиантами"
    },
    {
        value: "Золотой кулон с бриллиантами Крест"
    },
    {
        value: "Золотой комплект с рубинами и бриллиантами"
    },
    {
        value: "Антикварная золотая брошь- кулон с бриллиантами"
    },
    {
        value: "Антикварное колье неглиже с аметистами и бриллиантами"
    },
    {
        value: "Золотое кольцо с бриллиантом tiffani"
    },
    {
        value: "Кольцо с жемчугом и бриллиантами"
    },
    {
        value: "Итальянское золотое кольцо"
    },
    {
        value: "Золотое кольцо с белыми и черными  бриллиантами"
    },
    {
        value: "Итальянский золотой браслет"
    },
    {
        value: "Колье с бриллиантами Carrera y Carrera"
    },
    {
        value: "Золотая печатка с бриллиантами"
    },
    {
        value: "Антикварная золотая брошь с гранатами демантоидами"
    },
    {
        value: "Золотые серьги с аметистами и цитринами"
    },
    {
        value: "Золотой кулон с бриллиантом от ЭПЛ"
    },
    {
        value: "Золотой кулон с топазом и бриллиантами"
    },
    {
        value: "Золотые серьги с рубинами"
    },
    {
        value: "Платиновое кольцо с бриллиантами"
    },
    {
        value: "Золотой комплект с аметистами"
    },
    {
        value: "Золотые антикварные  серьги с бриллиантами"
    },
    {
        value: "Золотые серьги с бриллиантами  топазами и кварцем"
    },
    {
        value: "Золотое колье с бриллиантами Tiffani"
    },
    {
        value: "Серьги пусеты с сапфирами"
    },
    {
        value: "Золотое кольцо с изумрудами и бриллиантом"
    },
    {
        value: "Антикварные золотые серьги с бриллиантами алмазами"
    },
    {
        value: "Золотые серьги с бриллиантами  ЭПЛ"
    },
    {
        value: "Серебряные пусеты Tiffany Elsa Peretti"
    },
    {
        value: "Золотое колье с сапфирами и бриллиантами"
    },
    {
        value: "Золотые серьги с дымчатым кварцем и бриллиантами"
    },
    {
        value: "Золотые серьги  пусеты с фианитами"
    },
    {
        value: "Золотой кулон с бриллиантами и гранатом"
    },
    {
        value: "Золотой зажим для галстука Cartier"
    },
    {
        value: "Золотой кулон с аметистами и цитрином"
    },
    {
        value: "Золотые серьги с сапфирами и бриллиантами Pomellato"
    },
    {
        value: "Золотое колье с изумрудами и бриллиантами"
    },
    {
        value: "Золотые серьги с бриллиантами и самоцветами"
    },
    {
        value: "Золотое антикварное  кольцо с бриллиантами"
    },
    {
        value: "Золотое колье  с бриллиантами raima"
    },
    {
        value: "Золотой кулон сердце"
    },
    {
        value: "Подвес -кулон с сапфирами и топазом"
    },
    {
        value: "Золотые серьги бренд Bvlgari оригинал"
    },
    {
        value: "Золотое кольцо с бриллиантами4"
    },
    {
        value: "Золотое кольцо с аметрином"
    },
    {
        value: "Золотые серьги с аметистами и бриллиантами и сапфирами"
    },
    {
        value: "Золотое кольцо с изумрудом, сапфиром и бриллиантом"
    },
    {
        value: "Золотое колье с цепочкой и кулоном и с  бриллиантами"
    },
    {
        value: "Золотые серьги с зеленым кварцем"
    },
    {
        value: "Золотые пуссеты с бриллиантами"
    },
    {
        value: "Золотое колье Bvlgari"
    },
    {
        value: "Золотой комплекто с самоцветами"
    },
    {
        value: "Золотой браслет с бриллиантом"
    },
    {
        value: "Оригинальная золотая подвеска Pasquale Bruni"
    },
    {
        value: "Кулон с коньячным бриллиантом"
    },
    {
        value: "Золотое кольцо с бриллиантами и дымчатый кварц"
    },
    {
        value: "Комплект кольцо и серьги с изумрудами и бриллиантами"
    },
    {
        value: "Золотые серьги пусеты с сапфирами и бриллиантами"
    },
    {
        value: "Золотые серьги с бриллиантами и хризопразами"
    },
    {
        value: "Золотой кулон с бриллиантами и сапфирами"
    },
    {
        value: "Золотые советские серьги"
    },
    {
        value: "Золотое кольцо с  сапфирами, бриллиантами и гранатами"
    },
    {
        value: "Оригинальное золотое кольцо de Grisogono chiocciol"
    },
    {
        value: "Золотые серьги с бриллиантами  ссср"
    },
    {
        value: "Золотые серьги с топазом и бриллиантами"
    },
    {
        value: "Золотой браслет с бриллиантами и зелеными  аметистами"
    },
    {
        value: "Подвес с сапфирами и бриллиантами с цепочкой"
    },
    {
        value: "Золотое кольцо с бриллиантами аметистом  и цитрином"
    },
    {
        value: "Золотое кольцо с бриллиантами и жемчугом Таити"
    },
    {
        value: "Палладиевое кольцо с бриллиантами"
    },
    {
        value: "Золотые серьги с жемчугом и бриллиантами"
    },
    {
        value: "Золотое кольцо с янтарем"
    },
    {
        value: "Золотое кольцо рубинами сапфирами и изумрудами"
    },
    {
        value: "Золотое кольцо с нефритом"
    },
    {
        value: "Золотоые серьги с бриллиантами и жемчугом"
    },
    {
        value: "Золотое кольцо с бриллиантом и рубинами"
    },
    {
        value: "Золотые серьги с танцующими бриллиантами"
    },
    {
        value: "Золотые серьги с бриллиантами  и кварцем цвета виски"
    },
    {
        value: "Золотое кольцо с бирюзой и топазами"
    },
    {
        value: "Пусета серьга с бриллиантом"
    },
    {
        value: "Золотые серьги с  изумрудами"
    },
    {
        value: "Антикварная серебряная солонка"
    },
    {
        value: "Золотое кольцо с бриллиантами Tiffany"
    },
    {
        value: "Золотой зажим для галстука с бриллиантом"
    },
    {
        value: "Золотое колье с бриллиантами и сапфирами"
    },
    {
        value: "Золотое кольцо с изумрудом  бриллиантами"
    },
    {
        value: "Серьги с кварцем и бриллиантами"
    },
    {
        value: "Золотое кольцо с бриллтиантами"
    },
    {
        value: "Золотое кольцо с бриллиантами дорожка"
    },
    {
        value: "Золотые серьги с самоцветами глиптика"
    },
    {
        value: "Золотой браслет плетение перлина"
    },
    {
        value: "Золотой кулон с бриллиантом на цепи"
    },
    {
        value: "Золотой комплект с бриллиантами и эмалью"
    },
    {
        value: "Золотой кулон -брошь с бриллиантами и рубинами"
    },
    {
        value: "Золотое кольцо  с бриллиантами и изумрудами"
    },
    {
        value: "Золотое кольцо с изумрудами рубинами сапфирами и бриллиантами"
    },
    {
        value: "Золотой комплект с природными турмалинами"
    },
    {
        value: "Золотые серьги с голубыми топазами"
    },
    {
        value: "Золотое колье с изумрудом и бриллиантами"
    },
    {
        value: "Золотой подвес с топазом и бриллиантами"
    },
    {
        value: "Антикварная брошь с алмазами и сапфирами"
    },
    {
        value: "Золотые серьги пусеты с бриллиантами цитринами топазами  и Аметистами"
    },
    {
        value: "Золотой кулон с халцедоном и гранат зеленый"
    },
    {
        value: "Золотой браслет Tiffani &Co"
    },
    {
        value: "Золотая цепь новая плетение бисмарк средний"
    },
    {
        value: "Золотое колье с бриллиантом и самоцветами"
    },
    {
        value: "Золотые серьги с кварцем лимонным и хризолитами"
    },
    {
        value: "Золотые пусеты с бриллиантами и сапфирами"
    },
    {
        value: "Золотой кулон ссср с янтарем"
    },
    {
        value: "Золотое кольцо с бриллиантами рубинами и сапфирами"
    },
    {
        value: "Золотые серьги с бриллиантами, гранатами и родолитами"
    },
    {
        value: "Золотые серьги Розы"
    },
    {
        value: "Золотые серьги  с бриллиантами и рубинами"
    },
    {
        value: "Золотое кольцо с изумрудами и хризолитами"
    },
    {
        value: "Золотые серьги с топазами и фианитами"
    },
    {
        value: "Золотые серьги с бриллиантами  изумрудами и гранатами"
    },
    {
        value: "Золотые серьги с бриллиантами и аметистом"
    },
    {
        value: "Золотой комплект с кварцем жадеитом и топазом"
    },
    {
        value: "Золотое кольцо с бриллиантами Damas"
    },
    {
        value: "Золотое кольцо с кунцитом"
    },
    {
        value: "Подвес золотой с топазом и бриллиантами"
    },
    {
        value: "Золотой подвес с бриллиантами"
    },
    {
        value: "Золотое кольцо Boucheron"
    },
    {
        value: "Золотое колье крестик с бриллиантами"
    },
    {
        value: "Золотые серьги с жадеитами и бриллиантами"
    },
    {
        value: "Оригинальное золотое колье Bvlgari"
    },
    {
        value: "Золотой кулон крест с бриллиантами"
    },
    {
        value: "Золотое кольцо с бриллиантами и сапфироми и аметистами Grisogono Chiocciola"
    },
    {
        value: "Золотое колье Chopard с бриллиантами"
    },
    {
        value: "Золотое кольцо с Рубином   и бриллиантами"
    },
    {
        value: "Золотые серьги с бриллиантами  аметистами , топазом и цитрином"
    },
    {
        value: "Золотые серьги с бриллиантами Fibula"
    },
    {
        value: "Золотой кулон с бриллиантами и топазом"
    },
    {
        value: "Золотой комплект с гранатом и кварцем"
    },
    {
        value: "Золотой кулон с рубинами и изумрудами"
    },
    {
        value: "Золотой кулон с бриллиантами крестик"
    },
    {
        value: "Золотые серьги- пусеты с бриллиантами"
    },
    {
        value: "Золотое кольцо с жемчужиной и бриллиантами"
    },
    {
        value: "Золотй кулон  с бриллиантами и сапфирами"
    },
    {
        value: "Золотое колье Bvulgari"
    },
    {
        value: "Золотой кулон советский с корундом"
    },
    {
        value: "Золотое колье Roberto Coin с бриллиантами и рубином"
    },
    {
        value: "Золотые серьги с хризобериллами и морганитами"
    },
    {
        value: "Комплект серьги и кольцо с бриллиантами и сапфирами"
    },
    {
        value: "Золотое кольцо Damiani Veramore c бриллиантом"
    },
    {
        value: "Золотое кольцо с топазом и с  бриллиантами"
    },
    {
        value: "Золотой антикварный браслет с бриллиантами"
    },
    {
        value: "Золотой браслет с самоцветами и бриллиантами"
    },
    {
        value: "Колье золотое с бриллиантами Chaumet"
    },
    {
        value: "Золотое кольцо с бриллиантом  бренд Piaget"
    },
    {
        value: "Золотой браслет плетение  якорный"
    },
    {
        value: "Золотое кольцо с бриллиантами шпинелью"
    },
    {
        value: "Золотое колье с бриллиантами и ониксом"
    },
    {
        value: "Золотые серьги с бирюзой топазами и иолитами"
    },
    {
        value: "Золотое кольцо с бриллиантами и сапфирами Lee Pizzo"
    },
    {
        value: "Золотая антикварная брошь с бриллиантами"
    },
    {
        value: "Золотые серьги с кварцем и гранатами"
    },
    {
        value: "Золотой кулон с изумрудом и бриллиантами"
    },
    {
        value: "Золотое кольцо с хризолитами и кварцем"
    },
    {
        value: "Золотое кольцо с бриллиантами и дымчатым  кварцем"
    },
    {
        value: "Платиновое кольцо c бриллиантом"
    },
    {
        value: "Золотое кольцо с изумрудом и бриллиантом"
    },
    {
        value: "Золотой кулон с кварцем, жадеитом и топазом"
    },
    {
        value: "Золотое кольцо с гранатами (пиропами ) и  с бриллиантами"
    },
    {
        value: "Золотое колье с бриллиантами бренд Tiffany & Co"
    },
    {
        value: "Золотая цепь змейка-снейк"
    },
    {
        value: "Золотой браслет с рубином и бриллиантами"
    },
    {
        value: "Золотое кольцо советское обручальное"
    },
    {
        value: "Золотое кольцо с сапфирами Dhamani"
    },
    {
        value: "Антикварный подвес эмалью и  гранатами"
    },
    {
        value: "Золотой комплект кольцо и серьги с бриллиантами хризолитами и аметистами"
    },
    {
        value: "Золотое кольцо черепашка с фианитами"
    },
    {
        value: "Золотое кольцо с бриллиантами и аметистои"
    },
    {
        value: "Антикварная золотая брошь с бриллиантами"
    },
    {
        value: "Золотое кольцо с бриллиантами Carrera y Carrera"
    },
    {
        value: "Золотой кулон с сапфиром"
    },
    {
        value: "Золотые серьги с самоцветами и бриллиантами"
    },
    {
        value: "Золотое кольцо с бриллиантами и грифонами"
    },
    {
        value: "Золотое колье с сапфирами"
    },
    {
        value: "Золотое кольцо с бриллиантами Piaget"
    },
    {
        value: "Золотое кольцо с бриллиантами и  сапфирами"
    },
    {
        value: "Золотые серьги- пусеты  с бриллиантами и сапфирами"
    },
    {
        value: "Золотые серьги с бирюзой и бриллиантами"
    },
    {
        value: "Комплект кольцо и серьги с жемчугом и сапфирами"
    },
    {
        value: "Золотое кольцо с бриллиантами и турмалинами"
    },
    {
        value: "Золотой комплект с изумрудами и рубинами"
    },
    {
        value: "Золотые серьги с бриллиантами Damiani Infinito"
    },
    {
        value: "Золотой кулон подвес с бриллиантами и турмалином"
    },
    {
        value: "Брошь с рубинами и бриллиантами"
    },
    {
        value: "Золотое кольцо  с бриллиантами"
    },
    {
        value: "Золотая брошь с бриллиантами и сапфиром"
    },
    {
        value: "Золотые серьги с цитринами"
    },
    {
        value: "Золотые серьги с бриллиантами  Carrera Carrera"
    },
    {
        value: "Золотые серьги с синт корундами"
    },
    {
        value: "Золотой комплект с аметрином и бриллиантами"
    },
    {
        value: "Золотой браслет с бриллиантами и сапфирами"
    },
    {
        value: "Золотые серьги пусеты с бриллиантами и топазами"
    },
    {
        value: "Золотые кольцо с изумрудом и бриллиантами"
    },
    {
        value: "Золотой кулон с бриллиантами и гранатами"
    },
    {
        value: "Золотой браслет с бриллиантами LA NOVELLA"
    },
    {
        value: "Золотой комплект c бриллиантами Audemars Pigue"
    },
    {
        value: "Золотой кулон -подвес с дымчатым кварцем"
    },
    {
        value: "Золотые серьги с бриллиантами в стиле Cartier"
    },
    {
        value: "Золотое кольцо с авантюрином СССР"
    },
    {
        value: "Золотые серьги с изумрудами и бриллиантами с бриллиантами"
    },
    {
        value: "Золотое колье с сапфирами и бриллиантами Mauro Conti"
    },
    {
        value: "Золотые серьги -пусеты с бриллиантами"
    },
    {
        value: "Антикварный золотой браслет с бриллиантами"
    },
    {
        value: "Золотое кольцо Ягуар с бриллиантами"
    },
    {
        value: "Золотое кольцо с Аметистами  бриллиантами"
    },
    {
        value: "Золотое колье с бриллиантами и аметистами"
    },
    {
        value: "Золотой кулон подвес м аметистом и бриллиантами"
    },
    {
        value: "Жемчужный браслет Микимото"
    },
    {
        value: "Золотой кулон с рубинами и бриллиантами"
    },
    {
        value: "Золотая брошь с бриллиантами и гранатом"
    },
    {
        value: "Комплект с бриллиантами кольцо и серьги"
    },
    {
        value: "Золотой комплект с топазами и бриллиантами"
    },
    {
        value: "Серебряный кулон с цирконием"
    },
    {
        value: "Часы Bulova"
    },
    {
        value: "Золотой комплект с хризолитами"
    },
    {
        value: "Золотой антикварный браслет"
    },
    {
        value: "Антикварное золотое кольцо"
    },
    {
        value: "Золотое колье с жемчугом"
    },
    {
        value: "Золотой браслет плетение бисмарк малое"
    },
    {
        value: "Колье -браслет с жемчугом и бриллиантами"
    },
    {
        value: "Золотое кольцо с перламутром и бриллиантами"
    },
    {
        value: "Золотые серьги с иолитами-кордиерит и бриллиантами"
    },
    {
        value: "Золотое кольцо обручальное советское"
    },
    {
        value: "Золотое кольцо сцветными фантазийными бриллиантами бриллиантами"
    },
    {
        value: "Золотая цепь фантазийного плетения"
    },
    {
        value: "Золотые серьги с бриллиантами и гранатами"
    },
    {
        value: "Оригинальное золотое кольцо с бриллиантом Pomellat"
    },
    {
        value: "Платиновые серьги  с бриллиантами и аметистами"
    },
    {
        value: "Золотые серьги пусеты с рубинами"
    },
    {
        value: "Золотой кулон с самоцветами"
    },
    {
        value: "Антикварное колье с аметистом"
    },
    {
        value: "Золотое кольцо с бриллиантами изумрудами и гранатами"
    },
    {
        value: "Золотой браслет с бриллиантами и дымчатым кварцем"
    },
    {
        value: "Золотой комплект с розовым опалом"
    },
    {
        value: "Золотая цепь новая плетение двойной ромб"
    },
    {
        value: "Золотой кулон с дымчатым кварцем"
    },
    {
        value: "Золотой браслет Dior"
    },
    {
        value: "Оригинальное колье с розовым кварцем Chopard"
    },
    {
        value: "Золотое кольцо с бриллиантом и аметистами"
    },
    {
        value: "Золотое кольцо с рубином и сапфирами"
    },
    {
        value: "Золотая брошь с бриллиантом"
    },
    {
        value: "Золотое кольцо с бриллиантами и эмалью Bibigi"
    },
    {
        value: "Золотые кольцо  с бриллиантами"
    },
    {
        value: "Золотой браслет с бриллиантами и гранатами"
    },
    {
        value: "Золотой комплект с бриллиантами и кварцем"
    },
    {
        value: "Золотой комплеет с аметистами и топазами"
    },
    {
        value: "Антикварная золотая брошь с рубином и бриллиантами"
    },
    {
        value: "Золотое колье с жемчугом и бриллиантами Mikimoto"
    },
    {
        value: "Золотое кольцо с бриллиантинами и самоцветами"
    },
    {
        value: "Кольцо с бриллиантами"
    },
    {
        value: "Золотое кольцо с аметистами зелеными"
    },
    {
        value: "Золотой кулон с бриллиантами и бирюзой"
    },
    {
        value: "Золотой подвес с самоцветами"
    },
    {
        value: "Золотое колье с пренитом , бриллиантами и турмалинами"
    },
    {
        value: "Золотые серьги пусеты  с фианитами"
    },
    {
        value: "Комплет из золота \" Узелки\""
    },
    {
        value: "Антикварный золотой браслет с Аметистом"
    },
    {
        value: "Золотое кольцо с бриллиантами \" Подсолнухи\""
    },
    {
        value: "Серьги с бриллиантами Chaumet"
    },
    {
        value: "Золотые серьги с аметистами гранатами и топазами"
    },
    {
        value: "Колье с рубинами и бриллиантами"
    },
    {
        value: "Золотой кулон с бриллиантами Piaget"
    },
    {
        value: "Колье с бриллиантами Pasquale Bruni"
    },
    {
        value: "Золотой комплект с цитрином"
    },
    {
        value: "Золотой кулон-подвес  с кварцем изумрудами и хризолитами"
    },
    {
        value: "Золотые серьги с гиацинтом и  бриллиантами"
    },
    {
        value: "Жемчужные бусы с золотой фурнитурой"
    },
    {
        value: "Золотое кольцо с турмалином  ибриллиантами"
    },
    {
        value: "Комплект серьги и кольцо с гранатами и  бриллиантами"
    },
    {
        value: "Золотые серьги с бриллиантами и  сапфирами"
    },
    {
        value: "Золотой комплект с рубинами"
    },
    {
        value: "Золотое кольцо с рубином синтетическим"
    },
    {
        value: "Оригинальное платиновое кольцо Tiffany"
    },
    {
        value: "Золотые серьги с изумрудами и рубинами"
    },
    {
        value: "Золотой браслет плетение бисмарк"
    },
    {
        value: "Золотое кольцо ссср чалма"
    },
    {
        value: "Золотое колье с сапфирами и бриллиантами Bvulgari"
    },
    {
        value: "Мундштук антикварный"
    },
    {
        value: "Золотое кольцо с рубином синт и фианитами"
    },
    {
        value: "Оригинальное колье с бриллиантами de Grisogono"
    },
    {
        value: "Золотое кольцо с жемчугом и бриллиантом"
    },
    {
        value: "Антикварное колье с бриллиантами и аквамарином"
    },
    {
        value: "Золотое кольцо с бриллиантами Аметистом"
    },
    {
        value: "Золотой браслет с агатом"
    },
    {
        value: "Золотые серьги с природной шпинелью"
    },
    {
        value: "Оригинальное золотое кольцо Carrera Promesa"
    },
    {
        value: "Золотое колье с бриллиантами Chopard"
    },
    {
        value: "Золотое кольцо дорожка с бриллиантами"
    },
    {
        value: "Золотое кольцо СССР с бриллиантом"
    },
    {
        value: "Золотое кольцо с гранатом родолит и  бриллиантами"
    },
    {
        value: "Золотой кулон с янтарем"
    },
    {
        value: "Серебряное кольцо Tiffany"
    },
    {
        value: "Золотой кулон с бриллиантами и жемчужиной"
    },
    {
        value: "Золотое кольцо с жемчугом и  бриллиантами"
    },
    {
        value: "Золотые  серьги пуссеты"
    },
    {
        value: "Золотой кулон с хризолитом"
    },
    {
        value: "Золотые серьги с Аметистами и хризолитами"
    },
    {
        value: "Золотые серьги с аметистами и кварцем"
    },
    {
        value: "Золотое кольцо с Гиацинтом"
    },
    {
        value: "Золотое кольцо с цитрином и аметистами"
    },
    {
        value: "Подвес с изумрудом и бриллиантами"
    },
    {
        value: "Золотое кольцо с сапфиром  и   бриллиантами"
    },
    {
        value: "Золотые серьги с бриллиантами и шпинелью"
    },
    {
        value: "Золотой браслет с фианитами"
    },
    {
        value: "Золотой комплект с бриллиантами и сапфирами"
    },
    {
        value: "Золотое кольцо Tiffany&Co"
    },
    {
        value: "Золотые серьги с турмалинами и бриллиантами"
    },
    {
        value: "Золотая цепь антикварная  для часов"
    },
    {
        value: "Золотой значок с бриллиантами сапфирами и рубинами"
    },
    {
        value: "Золотые серьги с синтетич александр"
    },
    {
        value: "Золотое кольцо с бриллиантами и кварцем Pasquale Bruni"
    },
    {
        value: "Золотые серьги с кварцами и бриллиантами"
    },
    {
        value: "Золотое кольцо с кварцем и топазами"
    },
    {
        value: "Золотой крест с бриллиантами"
    },
    {
        value: "Золотые серьги с жемчугом и  бриллиантами"
    },
    {
        value: "Оригинальные золотое кольцо Chaumet"
    },
    {
        value: "Золотой кулон с жемчугом и с бриллиантами и"
    },
    {
        value: "Золотое кольцо с топазами и бриллиантами"
    },
    {
        value: "Серебряные серьги с цирконием"
    },
    {
        value: "Золотое кольцо с бриллиантами и жемчугом  GV"
    },
    {
        value: "Золотое кольцо Bvlgari с бриллиантами"
    },
    {
        value: "Золотое кольцо с Рубинами сапфирами и бриллиантами"
    },
    {
        value: "Антикварные золотые серьги с рубинами"
    },
    {
        value: "Золотой кулон с изумрудом турмалином и сапфиром"
    },
    {
        value: "Золотые серьги -клипсы с топазами и бриллиантами"
    },
    {
        value: "Золотое кольцо с топазом бриллиантами и рубинами Pomellato"
    },
    {
        value: "Золотые серьги пусеты изумрудами"
    },
    {
        value: "Золотые серьги с бриллиантами  сапфирами и изумрудами"
    },
    {
        value: "Золотое кольцо с кристаллами сваровски"
    },
    {
        value: "Золотые серьги с бриллиантами и ониксом"
    },
    {
        value: "Золотой браслет с бриллиантами Chopard"
    },
    {
        value: "Золотой кулон с бриллиантами и аметистами"
    },
    {
        value: "Золотое кольцо с бриллиантами топазом и сапфирами"
    },
    {
        value: "Золотые серьги с кварцем топазом и бриллиантами"
    },
    {
        value: "Золотое кольцо с бриллиантами Mauro Conti"
    },
    {
        value: "Золотое кольцо с лондон топазом"
    },
    {
        value: "Золотые серьги с аметистом и хризолитом Bvlgari"
    },
    {
        value: "Золотой комплект с бриллиантами и топазами"
    },
    {
        value: "Золотые серьги с бриллиантами  и кварцами"
    },
    {
        value: "Золотое кольцо с лунным камнем и бриллиантами"
    },
    {
        value: "Золотое кольцо с изумрудами и рубинами"
    },
    {
        value: "Золотые серьги с бриллиантами Frank Muller"
    },
    {
        value: "Золотая брошь с бриллиантами изумрудами сапфирами и рубинами"
    },
    {
        value: "Золотое кольцо змейка с бриллиантами"
    },
    {
        value: "Золотое кольцо с Звездчатым сапфиром и сапфирами"
    },
    {
        value: "Золотое кольцо с Аметистом Цитрином Топазом"
    },
    {
        value: "Золотые серьги-пусеты с бриллиантами"
    },
    {
        value: "Золотой кулон Mikimoto с жемчугом и бриллиантами"
    },
    {
        value: "Серьги с бриллиантами 0.87ct Chaumet Annea"
    },
    {
        value: "Золотые серьги с бриллиантами и   Топазами"
    },
    {
        value: "Золотой кулон с цитрином"
    },
    {
        value: "Золотой зажим для галстука с бриллиантами"
    },
    {
        value: "Золотой Кулон с бриллиантами и перламутр"
    },
    {
        value: "Серьги с сапфирами и бриллиантами"
    },
    {
        value: "Золотое кольцо с шпинелью и бриллиантами"
    },
    {
        value: "Золотое кольцо с бриллиантами и синт изумрудом"
    },
    {
        value: "Серебряное кольцо с цирконом"
    },
    {
        value: "Колье с бриллиантами кулон и цепочка"
    },
    {
        value: "Золотое кольцо с турмалинами"
    },
    {
        value: "Золотые серьги с зеленым аметистом"
    },
    {
        value: "Золотое кольцо со шпинелью  бриллиантами"
    },
    {
        value: "Золотое кольцо с бриллиантами и сердоликом"
    },
    {
        value: "Колье с бриллиантами Graff"
    },
    {
        value: "Антикварное золотое кольцо с сапфиром и бриллиантами"
    },
    {
        value: "Оригинальное золотое кольцо B.Zero Bvlgari"
    },
    {
        value: "Комплект серьги и кольцо с  бриллиантами и сапфирами"
    },
    {
        value: "Золотые серьги с бриллиантами пусеты"
    },
    {
        value: "Золотой кулон с аметистом бриллиантом и  цепочкой"
    },
    {
        value: "Золотое кольцо аметистами хризолитами и топазом"
    },
    {
        value: "Золотое кольцо с сердоликом"
    },
    {
        value: "Золотое кольцо с аметистом и  бриллиантами"
    },
    {
        value: "Золотые серьги с бриллиантами и жемчугом Таити"
    },
    {
        value: "Платиновое кольцо с бриллиантом"
    },
    {
        value: "Золотое кольцо с бриллиантами под Chopard"
    },
    {
        value: "Антикварное золотое кольцо с бриллиантами"
    },
    {
        value: "Золотой кулон Крест с изумрудами и бриллиантами"
    },
    {
        value: "Золотое кольцо с хризолитами"
    },
    {
        value: "Золотое кольцо с бирюзой и бриллиантами"
    },
    {
        value: "Золотое кольцо с бриллиантами и аквамарином"
    },
    {
        value: "Золотой кулон \"Черепашка\""
    },
    {
        value: "Золотая брошь с бриллиантами и жемчугом"
    },
    {
        value: "Золотые клипсы с бриллиантами Van Cleef & Arpels"
    },
    {
        value: "Антикварная золотая брошь с Аметистом"
    },
    {
        value: "Золотая цепь новая плетения нонна среднее"
    },
    {
        value: "Золотой браслет плетение нонна средний"
    },
    {
        value: "Золотое кольцо с зеленым кварцем"
    },
    {
        value: "Золотое кольцо Stephen Webster"
    },
    {
        value: "Золотой кулон с белым Агатом и топазами"
    },
    {
        value: "Золотой кулон с бриллиантами сапфирами и рубинами"
    },
    {
        value: "Золотое кольцо с бриллиантами аметистами , цитринами , топазами"
    },
    {
        value: "Золотой браслет бриллиантами и сапфирами"
    },
    {
        value: "Золотое кольцо с бриллиантом и топазами"
    },
    {
        value: "Золотой комплект с бирюзой и бриллиантами"
    },
    {
        value: "Золотое кольцо с перламутром и бриллиантом"
    },
    {
        value: "Золотое кольцо с топазом  , хризолитом ,турмалином"
    },
    {
        value: "Золотые серьги с хризолитами и бриллиантами"
    },
    {
        value: "Золотое советское кольцо обручальное"
    },
    {
        value: "Золотые серьги с бриллиантами  черными и рубинами"
    },
    {
        value: "Золотой комплект с бриллиантами Chaumet Liens"
    },
    {
        value: "Золотой кулон с  бриллиантами"
    },
    {
        value: "Золотое кольцо с халцедоном топазами и бриллиантами"
    },
    {
        value: "Золотой брендовый браслет Jacob & Со"
    },
    
]